import ModuleWrapper from "../utils/ModuleWrapper";
import type { ModuleWrapperProps } from "../../types/modules";

type ModuleProps = Omit<ModuleWrapperProps, "moduleOrder">;

export function SuppliesModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={1} />;
}

export function BackpackModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={2} />;
}

export function FirstAidModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={3} />;
}

export function DocumentsModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={4} />;
}

export function CrisisModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={5} />;
}

export function EvacuationModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={6} />;
}

export function FitBodyModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={7} />;
}

export function MentalStrengthModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={8} />;
}

export function CommunityModule(props: ModuleProps) {
  return <ModuleWrapper {...props} moduleOrder={9} />;
}
